






import { Component, Vue, Prop } from 'vue-property-decorator';
import { User } from '@pjn/core/model/app/User';
import { BooleanProp } from '@pjn/vue-core/component';

/**
 * Avatar de usuario.
 * 
 * Muestra su inicial en un avatar (circulo).
 */
@Component
export default class UserIcon extends Vue {
  
  /** Usuario a mostrar */
  @Prop() user: User;

  @Prop({type: Number, default: 48}) size: number;

  /** Genera un shadow al hacer over */
  @BooleanProp(true) over: boolean;

  private get fontStyle() {
    return {
      'font-size': (this.size / 2) + 'px !important'
    }
  }

  private get inicial() {
    return this.user && this.user.displayName ? this.user.displayName.charAt(0) : '';
  }
}
